import React from "react";
import PropTypes from "prop-types";

const COMPONENT_TAG = "[BrandLib SelectBox]: ";
const DEFAULT_SELECTED_INDEX = "0";

class SelectBox extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.input = React.createRef();
	}

	componentDidMount() {
		if (window.BrandLib && window.BrandLib.forms) {
			const { optionsList, placeholder, onChange, selectedIndex } = this.props;
			try {
				const objBrandLib = {
					list: optionsList,
					placeholder,
					selectedValue: selectedIndex || DEFAULT_SELECTED_INDEX,
					inputEvents: {
						change: (event) => {
							onChange(event.target);
						}
					}
				};

				window.BrandLib.forms.selectBox(this.input.current, objBrandLib);
			} catch (exception) {
				console.error(`${COMPONENT_TAG}BrandLib error on selectBox - ${exception}`);
			}
		}

		if (this.props.onMount !== undefined) {
			this.props.onMount(this.input.current);
		}
	}

	componentWillUnmount() {
		if (this.props.onUnmount !== undefined) {
			this.props.onUnmount(this.input.current);
		}
	}

	render() {
		const {
			id,
			name,
			placeholder,
			isDisabled,
			optionsList,
            selectedIndex,
            formitemtype
		} = this.props;

		if (optionsList && optionsList.length > 0) {
			return (
				<React.Fragment>
					<select
						id={id}
                        name={name}
                        formitemtype={formitemtype}
						disabled={isDisabled}
						placeholder={placeholder}
						ref={this.input}
						defaultValue={optionsList[selectedIndex || DEFAULT_SELECTED_INDEX]}
					/>
				</React.Fragment>
			);
		}
		console.log(`${COMPONENT_TAG} an empty list was passed`);
		return null;
	}
}

SelectBox.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string,
	optionsList: PropTypes.array.isRequired,
	placeholder: PropTypes.string.isRequired,
	isDisabled: PropTypes.bool,
	selectedIndex: PropTypes.string,
	onMount: PropTypes.func,
	onUnmount: PropTypes.func
};

export default SelectBox;
